module.exports = __webpack_public_path__ + "img/image004.b4901458.jpg";